import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "src/app/config";
import { localStoreConfig } from "src/app/constants";

const initialState = {
  token: "",
  mobileNumber: "",
  isLoading: false,
  isError: false,
  isSuccess: false,
  error: null,
};

export const sendOtp = createAsyncThunk("auth/sendOtp", async (thunkAPI, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
  try {
    const response = await axiosApi().post(`/auth/send-otp`, {
      mobileNumber: thunkAPI.mobileNumber,
    });

    localStorage.setItem(localStoreConfig.mobileNumber, thunkAPI.mobileNumber);

    return fulfillWithValue(JSON.parse(JSON.stringify(response.data)));
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to send OTP. Please try again.";
    return rejectWithValue(errorMessage);
  }
});

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (thunkAPI, { rejectWithValue }) => {
    try {
      const response = await axiosApi().post(`/auth/verify-otp`, {
        mobileNumber: thunkAPI.mobileNumber,
        otp: thunkAPI.otp,
      });

      const secureToken = response.data?.token;
      const organizationId = response.data?.organizationId;

      if (secureToken) {
        localStorage.setItem(localStoreConfig.secureToken, secureToken);
      }

      if (organizationId) {
        localStorage.setItem(localStoreConfig.organizationId, organizationId);
      }

      return JSON.parse(JSON.stringify(response?.data ?? {}));
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Invalid OTP. Please try again.";
      return rejectWithValue(errorMessage);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearSuccess: (state) => {
      state.isSuccess = false;
      state.isError = false;
      state.isLoading = false;
    },
    setMobileNumber: (state, payload) => {
      state.mobileNumber = payload?.payload?.mobileNumber;
    },
    setToken: (state, payload) => {
      state.token = payload?.payload?.token;
    },
    logout: (state) => {
      // Clear Redux state
      state.token = "";
      state.mobileNumber = "";
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = false;
      state.error = null;
      
      // Clear localStorage
      localStorage.removeItem(localStoreConfig.secureToken);
      localStorage.removeItem(localStoreConfig.organizationId);
      localStorage.removeItem(localStoreConfig.mobileNumber);
      localStorage.removeItem(localStoreConfig.selectedCompanyUserId);
      localStorage.removeItem(localStoreConfig.selectedClientMap);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendOtp.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(sendOtp.fulfilled, (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    });
    builder.addCase(sendOtp.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isError = true;
    });
    builder.addCase(verifyOtp.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.token = action.payload?.token;
    });
    builder.addCase(verifyOtp.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isError = true;
    });
  },
});

export const { clearState, clearSuccess, setMobileNumber, setToken, logout } =
  authSlice.actions;
export default authSlice.reducer;
